var chunkMapping = {
	"30": [
		5030
	],
	"188": [
		4188
	],
	"192": [
		6192
	],
	"228": [
		228
	],
	"396": [
		4396
	],
	"454": [
		8454
	],
	"775": [
		8775
	],
	"810": [
		9810
	],
	"828": [
		6828
	],
	"935": [
		9935
	]
};
var idToExternalAndNameMapping = {
	"228": [
		"default",
		"./App",
		429
	],
	"4188": [
		"default",
		"./Billing",
		3286
	],
	"4396": [
		"default",
		"./Workflows",
		4006
	],
	"5030": [
		"default",
		"./TechPerformance",
		7483
	],
	"6192": [
		"default",
		"./SupportChatbot",
		8923
	],
	"6828": [
		"default",
		"./Quotes",
		2654
	],
	"8454": [
		"default",
		"./App",
		9215
	],
	"8775": [
		"default",
		"./ClientAppsOps",
		2775
	],
	"9810": [
		"default",
		"./AiOps",
		2775
	],
	"9935": [
		"default",
		"./PhoneAgentAdmin",
		9217
	]
};
var idToRemoteMap = {
	"228": [
		{
			"externalType": "script",
			"name": "bellwetherFormsRemote"
		}
	],
	"4188": [
		{
			"externalType": "script",
			"name": "billing"
		}
	],
	"4396": [
		{
			"externalType": "script",
			"name": "workflows"
		}
	],
	"5030": [
		{
			"externalType": "script",
			"name": "techPerformanceRemote"
		}
	],
	"6192": [
		{
			"externalType": "script",
			"name": "supportChatbotRemote"
		}
	],
	"6828": [
		{
			"externalType": "script",
			"name": "quotes"
		}
	],
	"8454": [
		{
			"externalType": "script",
			"name": "qbrReport"
		}
	],
	"8775": [
		{
			"externalType": "script",
			"name": "aiOpsRemote"
		}
	],
	"9810": [
		{
			"externalType": "script",
			"name": "aiOpsRemote"
		}
	],
	"9935": [
		{
			"externalType": "script",
			"name": "phoneAgentRemote"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"228": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 429,
		"remoteName": "bellwetherFormsRemote"
	},
	"4188": {
		"shareScope": "default",
		"name": "./Billing",
		"externalModuleId": 3286,
		"remoteName": "billing"
	},
	"4396": {
		"shareScope": "default",
		"name": "./Workflows",
		"externalModuleId": 4006,
		"remoteName": "workflows"
	},
	"5030": {
		"shareScope": "default",
		"name": "./TechPerformance",
		"externalModuleId": 7483,
		"remoteName": "techPerformanceRemote"
	},
	"6192": {
		"shareScope": "default",
		"name": "./SupportChatbot",
		"externalModuleId": 8923,
		"remoteName": "supportChatbotRemote"
	},
	"6828": {
		"shareScope": "default",
		"name": "./Quotes",
		"externalModuleId": 2654,
		"remoteName": "quotes"
	},
	"8454": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 9215,
		"remoteName": "qbrReport"
	},
	"8775": {
		"shareScope": "default",
		"name": "./ClientAppsOps",
		"externalModuleId": 2775,
		"remoteName": "aiOpsRemote"
	},
	"9810": {
		"shareScope": "default",
		"name": "./AiOps",
		"externalModuleId": 2775,
		"remoteName": "aiOpsRemote"
	},
	"9935": {
		"shareScope": "default",
		"name": "./PhoneAgentAdmin",
		"externalModuleId": 9217,
		"remoteName": "phoneAgentRemote"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}